import React from "react";
import { Box, Link } from "@mui/material";

import { withDefaultProps } from "fond/utils/withDefaultProps";

import imageMapImprovements from "./images/self-service-release/map-improvements.png";
import imageNewHomepage from "./images/self-service-release/new-homepage.png";
import imageSelfService from "./images/self-service-release/self-service.png";
import BasicTour, { Slides } from "./BasicTour";

import { BodyText, CenteredSlideImage } from "./BasicTour.styles";

const SlideImage = withDefaultProps(CenteredSlideImage, { width: 241, height: 219, alt: "" });

const slides: Slides = [
  {
    image: <SlideImage src={imageSelfService} />,
    title: "FOND Feature Release: Self Service",
    content: (
      <Box maxWidth={700}>
        <BodyText component="p">It is now possible to fully self-manage your FOND subscription. Workspace administrators are able to:</BodyText>
        <ul>
          <li>Select from annual or quarterly options for future subscriptions, providing greater flexibility in how you use FOND</li>
          <li>Choose from Credit Card, ACH, or invoice billing options, to meet all financing needs</li>
          <li>Enable auto-renewal for uninterrupted access</li>
          <li>Upgrade the current subscription, adding more licenses or premises</li>
          <li>Make changes to upcoming subscriptions</li>
          <li>
            View all subscription information and invoicing within FOND, so that you know exactly when your subscription is due for renewal or running
            out of premises
          </li>
        </ul>
        <BodyText>
          Read more in our{" "}
          <Link href="https://fondhelp.biarrinetworks.com/fond-planner-pricing" target="_blank">
            Knowledge Base
          </Link>
          .
        </BodyText>
      </Box>
    ),
  },
  {
    image: <SlideImage src={imageNewHomepage} />,
    title: "FOND Feature Release: New home page",
    content: (
      <Box maxWidth={700}>
        <BodyText component="p">The FOND Home page has a new look. This provides easier access to:</BodyText>
        <ul>
          <li>View and manage your FOND subscription</li>
          <li>Invite new members to the workspace</li>
          <li>Recently viewed projects</li>
          <li>Help options to contact support, access knowledge base, and submit feedback</li>
        </ul>
      </Box>
    ),
  },
  {
    image: <SlideImage src={imageMapImprovements} />,
    title: "FOND Feature Release: Mapping improvements",
    content: (
      <Box maxWidth={700}>
        <BodyText component="p">Additional FOND map improvements:</BodyText>
        <ul>
          <li>Use Street View to explore the environment</li>
          <li>Adjust base map transparency for clearer visibility of Network Design features</li>
        </ul>
        <BodyText>
          Read more in our{" "}
          <Link href="https://fondhelp.biarrinetworks.com/knowledge/moving-around-the-map-in-fond" target="_blank">
            Knowledge Base
          </Link>
          .
        </BodyText>
      </Box>
    ),
  },
];

interface IProps {
  onComplete(): void;
}

const SelfServiceTour: React.FC<IProps> = ({ onComplete }) => (
  <BasicTour onComplete={onComplete} slides={slides} name="self-service-tour" fitContent skipText="Skip" />
);

export default SelfServiceTour;
